// 刷新令牌的请求状态
let isTokenRefreshing = false
// 等待令牌刷新的请求队列
let tokenRefreshQueue = []

/**
 * 获取令牌刷新状态
 * @returns {boolean} 是否正在刷新令牌
 */
export function getTokenRefreshStatus () {
  return isTokenRefreshing
}

/**
 * 设置令牌刷新状态
 * @param {boolean} status - 刷新状态
 */
export function setTokenRefreshStatus (status) {
  isTokenRefreshing = status
}

/**
 * 添加等待令牌刷新的请求
 * @param {Function} callback - 请求回调函数
 */
export function addToTokenRefreshQueue (callback) {
  tokenRefreshQueue.push(callback)
}

/**
 * 执行等待队列中的请求
 * @param {string} newToken - 新的访问令牌
 */
export function executeTokenRefreshQueue (newToken) {
  tokenRefreshQueue.forEach(callback => callback(newToken))
  tokenRefreshQueue = []
}
